// Refined color palette for B2B dashboard
export const colors = {
    primary: "#2c3e50", // Dark blue-gray - primary brand color
    secondary: "#34495e", // Darker blue-gray - secondary brand color
    accent1: "#3498db", // Blue - primary accent
    accent2: "#2980b9", // Darker blue - secondary accent
    accent3: "#1abc9c", // Teal - tertiary accent
    accent4: "#16a085", // Darker teal - quaternary accent
    neutral1: "#ecf0f1", // Light gray - background
    neutral2: "#bdc3c7", // Medium gray - borders
    neutral3: "#7f8c8d", // Dark gray - text secondary
    success: "#27ae60", // Green - success states
    warning: "#f39c12", // Amber - warning states
    error: "#e74c3c", // Red - error states
    info: "#3498db", // Blue - info states
    chartColors: [
      "#3498db", // Blue
      "#2980b9", // Darker blue
      "#1abc9c", // Teal
      "#16a085", // Darker teal
      "#27ae60", // Green
      "#2ecc71", // Lighter green
      "#f39c12", // Amber
      "#e67e22", // Orange
      "#d35400", // Darker orange
      "#8e44ad", // Purple
    ],
  }